import { atomWithReset } from 'jotai/utils'

let defaultState = {
    loading: true,
    alertData: [],
    // this is needed because often the new data is displayed together with the old data where the new data is being transitioned in and the old data is being removed 
    // shownAlerts: [],
    error: null,
    lastRefreshed: null,
    cursor: null,
    alertCount: 0,
    nextPage: 1,
    isSorted: false,
}

export const highCostAtom = atomWithReset(defaultState);
export const highCostAlertsAtom = atomWithReset(defaultState);
export const clarificationsAtom = atomWithReset(defaultState);
export const priorAuthAtom = atomWithReset(defaultState);
export const nonCoveredAtom = atomWithReset(defaultState);
export const therapeuticIntAtom = atomWithReset(defaultState);
export const admissionMedsAtom = atomWithReset(defaultState);
export const refillTooSoonAtom = atomWithReset(defaultState);
export const pumpPickupAtom = atomWithReset(defaultState);
export const narcoticsRefillAtom = atomWithReset(defaultState);
export const alfNewScriptAtom = atomWithReset(defaultState);
export const alfCostResponseAtom = atomWithReset(defaultState);
export const unavailableMedicationAlertsAtom = atomWithReset(defaultState);

export const highCostAtomFilteredCount = atomWithReset(null);
export const highCostAlertsAtomFilteredCount = atomWithReset(null);
export const clarificationsAtomFilteredCount = atomWithReset(null);
export const priorAuthAtomFilteredCount = atomWithReset(null);
export const nonCoveredAtomFilteredCount = atomWithReset(null);
export const therapeuticIntAtomFilteredCount = atomWithReset(null);
export const admissionMedsAtomFilteredCount = atomWithReset(null);
export const refillTooSoonAtomFilteredCount = atomWithReset(null);

export const highCostAtomFiltered = atomWithReset([]);
export const highCostAlertsAtomFiltered = atomWithReset([]);
export const clarificationsAtomFiltered = atomWithReset([]);
export const priorAuthAtomFiltered = atomWithReset([]);
export const nonCoveredAtomFiltered = atomWithReset([]);
export const therapeuticIntAtomFiltered = atomWithReset([]);
export const admissionMedsAtomFiltered = atomWithReset([]);
export const refillTooSoonAtomFiltered = atomWithReset([]);
export const pumpPickupAtomFiltered = atomWithReset([]);
export const narcoticsRefillAtomFiltered = atomWithReset([]);
export const alfNewScriptAtomFiltered = atomWithReset([]);
export const alfCostResponseAtomFiltered = atomWithReset([]);
export const unavailableMedicationAlertsAtomFiltered = atomWithReset([]);

export const highCostAtomShownAlerts = atomWithReset([]);
export const highCostAlertsAtomShownAlerts = atomWithReset([]);
export const clarificationsAtomShownAlerts = atomWithReset([]);
export const priorAuthAtomShownAlerts = atomWithReset([]);
export const nonCoveredAtomShownAlerts = atomWithReset([]);
export const therapeuticIntAtomShownAlerts = atomWithReset([]);
export const admissionMedsAtomShownAlerts = atomWithReset([]);
export const pumpPickupAtomShownAlerts = atomWithReset([]);
export const narcoticsRefillAtomShownAlerts = atomWithReset([]);
export const alfNewScriptAtomShownAlerts = atomWithReset([]);
export const alfCostResponseAtomShownAlerts = atomWithReset([]);
export const unavailableMedicationAlertsAtomShownAlerts = atomWithReset([]);
export const refillTooSoonAtomShownAlerts = atomWithReset([]);

export const highCostAtomUserSettings = atomWithReset({ sortOrder: 1, hidden: false });
export const highCostAlertsAtomUserSettings = atomWithReset({ sortOrder: 1, hidden: false });
export const clarificationsAtomUserSettings = atomWithReset({ sortOrder: 2, hidden: false });
export const priorAuthAtomUserSettings = atomWithReset({ sortOrder: 3, hidden: false });
export const nonCoveredAtomUserSettings = atomWithReset({ sortOrder: 4, hidden: false });
export const therapeuticIntAtomUserSettings = atomWithReset({ sortOrder: 5, hidden: false });
export const admissionMedsAtomUserSettings = atomWithReset({ sortOrder: 6, hidden: false });
export const refillTooSoonAtomUserSettings = atomWithReset({ sortOrder: 9, hidden: false });
export const pumpPickupAtomUserSettings = atomWithReset({ sortOrder: 9, hidden: false });
export const narcoticsRefillAtomUserSettings = atomWithReset({ sortOrder: 9, hidden: false });
export const alfNewScriptAtomUserSettings = atomWithReset({ sortOrder: 10, hidden: false });
export const alfCostResponseAtomUserSettings = atomWithReset({ sortOrder: 12, hidden: false });
export const unavailableMedicationAlertsAtomUserSettings = atomWithReset({ sortOrder: 13, hidden: false });
export const hideResolvedAlertsAtomUserSettings = atomWithReset({ sortOrder: 14, hidden: false });

// export const highCostAtomFacilitySettings = atomWithReset({ sortOrder: 1, hidden: false });
// export const clarificationsAtomFacilitySettings = atomWithReset({ sortOrder: 2, hidden: false });
// export const priorAuthAtomFacilitySettings = atomWithReset({ sortOrder: 3, hidden: false });
// export const nonCoveredAtomFacilitySettings = atomWithReset({ sortOrder: 4, hidden: false });
// export const therapeuticIntAtomFacilitySettings = atomWithReset({ sortOrder: 5, hidden: false });
// export const admissionMedsAtomFacilitySettings = atomWithReset({ sortOrder: 6, hidden: false });
